import Vue from 'vue'
import Router from 'vue-router'
import axios from "axios";
import i18n from "../i18n";
import Hosts from "@/views/panel/base/Hosts";
import Plugins from "@/views/panel/base/Plugins";
import ThemeCategory from "@/views/panel/base/ThemeCategory";
import Themes from "@/views/panel/base/Themes";
import TicketList from "@/views/panel/Tickets/TicketList";
import TicketMessage from "@/views/panel/Tickets/TicketMessage";
import Websites from "@/views/panel/Websites/Websites";
import Domains from "@/views/panel/Websites/Domains";
import Factors from "@/views/panel/Websites/Factors";
import PersonnelList from "@/views/panel/Personnel/PersonnelList";
import AddPersonnel from "@/views/panel/Personnel/AddPersonnel";
import Settings from "@/views/panel/base/Settings";
import ExcelConvert from "@/views/panel/ReadExcel/ExcelConvert";
import PresentDetail from "@/views/panel/Payroll/PresentDetail";
import PayrollReceipt from "@/views/panel/Payroll/PayrollReceipt";
import PersonnelLeaveList from "@/views/panel/PersonLeaves/PersonnelLeaveList";
import Holidays from "@/views/panel/base/Holidays.vue";
import Shifts from "@/views/panel/base/Shifts.vue";

var selected_language = localStorage.getItem("language");
if (selected_language == '' || selected_language == "fa") {
    selected_language = 'fa'
    i18n.locale = "fa"
}
if (selected_language == "en") {
    i18n.locale = "en"
}
// Containers
const TheContainer = () => import('@/containers/TheContainer')

// Views
const Dashboard = () => import('@/views/Dashboard')

//Base
const Categories = () => import('@/views/panel/base/Categories')
const Brands = () => import('@/views/panel/base/Brands')




//Settings

// Views - Pages
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')
const Login = () => import('@/views/pages/Login')
const Register = () => import('@/views/pages/Register')


Vue.use(Router)

let router = new Router({
    mode: 'history', // https://router.vuejs.org/api/#mode
    linkActiveClass: 'active',
    scrollBehavior: () => ({y: 0}),
    routes: configRoutes(),

});


export default router

router.beforeEach((to, from, next) => {
    // this.sidebar_changer= this.$refs['sidebar_ref'].$el;

    //  console.log("before each" + " token is " + localStorage.getItem('token'));
    if (to.name == null) {
        document.title = "Panel";

    } else {
        document.title = to.name;

    }
    // console.log("before each"+next);
    if (to.path == '/') {
        //  window.location.href = '/home';
    }


    if (to.matched.some(record => record.meta.requiresAuth)) {
        // console.log("validate requiresAuth");

        if (localStorage.getItem('token') == null || localStorage.getItem('token') == '') {
            //    console.log("validate is null ");

            next({
                path: 'pages/login',
                params: {nextUrl: to.fullPath}
            })
        } else {
            validate_user(next, to);


        }
    } else if (to.matched.some(record => record.meta.guest)) {
        // if(localStorage.getItem('jwt') == null){
        next();
        // }
        // else{
        //     next({ name: 'userboard'})
        // }
    } else {
        next();
    }
});


function configRoutes() {
    return [
        {
            path: '/',
            redirect: '/dashboard',
        },
        {
            path: '/dashboard',
            name: ".dash",
            meta: {
                requiresAuth: true
            },
            component: TheContainer,
            children: [
                {
                    path: '/dashboard',
                    name: i18n.t("router.dashboard"),
                    meta: {
                        requiresAuth: true,
                    },
                    component: {
                        render(c) {
                            return c('router-view')
                        }
                    },
                    // component: Dashboard,
                    children: [
                        {
                            path: '/',
                            name: 'Dashboard Revenue',
                            component: Dashboard,
                            meta: {
                                requiresAuth: true,
                            }
                        },
                    ]
                },
                {
                    path: '/dashboard/personnel',
                    redirect: '/dashboard/personnel/list',
                    name: 'پرسنل',
                    component: {
                        render(c) {
                            return c('router-view')
                        }
                    },
                    children: [

                        {
                            path: 'list',
                            name: 'لیست پرسنل',
                            component:  PersonnelList,
                            meta: {
                                requiresAuth: true,
                            }
                        },
                        {
                            path: 'add',
                            name: 'کارمند جدید',
                            component:  AddPersonnel,
                            meta: {
                                requiresAuth: true,
                            }
                        },{
                            path: 'edit/:id',
                            name: 'ویرایش کارمند',
                            component:  AddPersonnel,
                            meta: {
                                requiresAuth: true,
                            }
                        },

{
                            path: 'personnel-leaves',
                            name: 'مرخصی کارمندان',
                            component:  PersonnelLeaveList,
                            meta: {
                                requiresAuth: true,
                            }
                        },




                    ]
                },
                {
                    path: '/dashboard/base',
                    redirect: '/dashboard/base/settings',
                    name: i18n.t("router.firstInformation"),
                    component: {
                        render(c) {
                            return c('router-view')
                        }
                    },
                    children: [
                        {
                            path: 'settings',
                            name: 'تنظیمات',
                            component:  Settings,
                            meta: {
                                requiresAuth: true,
                            }
                        }, {
                            path: 'holidays',
                            name: 'تعطیلات رسمی',
                            component:  Holidays,
                            meta: {
                                requiresAuth: true,
                            }
                        },{
                            path: 'shifts',
                            name: 'شیفت ها',
                            component:  Shifts,
                            meta: {
                                requiresAuth: true,
                            }
                        },
                        {
                            path: 'read-excel',
                            name: 'سیستم حضور غیاب',
                            component:  ExcelConvert,
                            meta: {
                                requiresAuth: true,
                            }
                        },




                    ]
                },
                {
                    path: '/dashboard/payroll',
                    redirect: '/dashboard/payroll/present_detail',
                    name: "ورود خروج کارمندان",
                    component: {
                        render(c) {
                            return c('router-view')
                        }
                    },
                    children: [

                        {
                            path: 'present_detail',
                            name: "ورود خروج کارمندان",
                            component: PresentDetail,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        },{
                            path: 'receipt',
                            name: "فیش حقوقی",
                            component: PayrollReceipt,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        },
                    ]
                },

//****************************************************

//****************************************************

//****************************************************
//****************************************************
            ]
        },
        {
            path: '/pages',
            redirect: '/404',
            name: 'Pages',
            component: {
                render(c) {
                    return c('router-view')
                }
            },
            children: [
                {
                    path: '404',
                    name: 'Page404',
                    component: Page404
                },
                {
                    path: '500',
                    name: 'Page500',
                    component: Page500
                },
                {
                    path: 'login',
                    name: 'Login',
                    component: Login
                },
                {
                    path: 'register',
                    name: 'Register',
                    component: Register
                }
            ]
        }
    ]
}

function validate_user(next, to) {

    let self = this;
    const formData = new FormData();
    let url;
    url = "/admin/validate_admin";
// next();
    formData.append('token', localStorage.getItem('token'))
    //  axios.defaults.headers.Authorization  =  'Brear '+localStorage.getItem('token');
    //  axios.defaults.headers.common['Hamid'] = "*";
    //  axios.defaults.headers.common['Authorization'] = 'Brear '+localStorage.getItem('token');
    // axios.defaults.headers.post['Authorization'] = 'Bearer ' + localStorage.getItem('token');
    // axios.defaults.headers.common['Access-Control-Allow-Origin'] = "*";
    // axios.defaults.headers.common['Transfer-Encoding'] = "chunked";
    // axios.defaults.headers.common['Access-Control-Allow-Headers'] = "Origin, X-Requested-With, Content-Type, Accept, Authorization";

    axios.post(url, formData).then((res) => {
        console.log("validate token is " + JSON.stringify(res.data));


        if (res.data==true) {
            // let permissions = res.data.data;
            // localStorage.setItem("permissions", permissions);

            //  console.log("validate is true");
            // let meta_role = to.meta.requiresRole;
            // console.log("user name is "+ this.user_permissions.includes("edit_settings"));
            // if (meta_role == null) {
            //     console.log("requiresRole is null");
                next();

            // } else {
            //     console.log("requiresRole is " + meta_role);
            //     let permissions = res.data.data;
            //     localStorage.setItem("permissions", permissions);
            //
            //     if (permissions.includes(meta_role)) {
            //         console.log("user has permissions ");
            //         next();
            //
            //     } else {
            //         next({
            //             path: '/pages/404',
            //             params: {nextUrl: to.fullPath}
            //         });
            //     }

            // }

        } else {
            //   console.log("validate is false last url is " + to.fullPath);
            localStorage.setItem('last_url', to.fullPath);

            next({
                path: '/pages/login',
            })
        }
        // return res.data;
    })

        // axios.post(  '/admin/category', {
        //     name: self.name,
        //     description: self.description,
        //     image: self.image,
        //     cat: 0,
        // }).then(function (response) {
        //     self.name = '';
        //     self.description = '';
        //     // localStorage.setItem("api_token", response.data.access_token);
        //     // self.$router.push({ path: 'notes' });
        // })
        .catch(function (error) {

            console.log(error);
        });
}

